'use client';

import type { ComponentProps } from 'react';

import { MHButton } from '../buttons/MHButton';

export function PrimaryButton(props: ComponentProps<typeof MHButton>) {
  return <MHButton variant="primary" {...props} />;
}
